import React from "react";

const SummaryFullName = ({
  width = 40,
  height = 40,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F6F8FA" />
      <path
        d="M21.5 26.75L20 28.25L18.5 26.75H14.7462C14.3494 26.75 13.9688 26.5924 13.6882 26.3118C13.4076 26.0312 13.25 25.6506 13.25 25.2537V14.7462C13.25 13.9197 13.9197 13.25 14.7462 13.25H25.2537C26.0802 13.25 26.75 13.9197 26.75 14.7462V25.2537C26.75 25.6506 26.5924 26.0312 26.3118 26.3118C26.0312 26.5924 25.6506 26.75 25.2537 26.75H21.5ZM25.25 25.25V14.75H14.75V25.25H19.121L20 26.129L20.879 25.25H25.25ZM16.979 24.635C16.5177 24.4352 16.0778 24.1895 15.6658 23.9015C16.1414 23.1643 16.7945 22.5581 17.565 22.1386C18.3356 21.719 19.1991 21.4995 20.0765 21.5C21.8765 21.5 23.4642 22.4053 24.41 23.7853C24.0059 24.0842 23.5727 24.3418 23.117 24.554C22.7697 24.0725 22.3128 23.6805 21.7842 23.4103C21.2555 23.1401 20.6702 22.9995 20.0765 23C18.7903 23 17.654 23.648 16.979 24.635ZM20 20.75C19.6553 20.75 19.3139 20.6821 18.9955 20.5502C18.677 20.4183 18.3876 20.2249 18.1438 19.9812C17.9001 19.7374 17.7067 19.448 17.5748 19.1295C17.4429 18.8111 17.375 18.4697 17.375 18.125C17.375 17.7803 17.4429 17.4389 17.5748 17.1205C17.7067 16.802 17.9001 16.5126 18.1438 16.2688C18.3876 16.0251 18.677 15.8317 18.9955 15.6998C19.3139 15.5679 19.6553 15.5 20 15.5C20.6962 15.5 21.3639 15.7766 21.8562 16.2688C22.3484 16.7611 22.625 17.4288 22.625 18.125C22.625 18.8212 22.3484 19.4889 21.8562 19.9812C21.3639 20.4734 20.6962 20.75 20 20.75ZM20 19.25C20.2984 19.25 20.5845 19.1315 20.7955 18.9205C21.0065 18.7095 21.125 18.4234 21.125 18.125C21.125 17.8266 21.0065 17.5405 20.7955 17.3295C20.5845 17.1185 20.2984 17 20 17C19.7016 17 19.4155 17.1185 19.2045 17.3295C18.9935 17.5405 18.875 17.8266 18.875 18.125C18.875 18.4234 18.9935 18.7095 19.2045 18.9205C19.4155 19.1315 19.7016 19.25 20 19.25Z"
        fill="#525866"
      />
    </svg>
  );
};

export default SummaryFullName;
